// extracted by mini-css-extract-plugin
export var details = "_kq-0";
export var inspectorPopover = "_kq-1";